import { connect } from 'react-redux';
import { compose } from 'recompose';

import EquipmentModal from './EquipmentModal';
import {
  closeEquipmentModal,
  dispatchCreateUpdateEquipment,
} from '../actions';

const mapStateToProps = (state) => {
  const { equipment } = state.equipmentList;

  return {
    showEquipmentModal: state.equipmentList.showEquipmentModal,
    initialValues: equipment,
  };
};

const mapDispatchToProps = {
  closeEquipmentModal,
  dispatchCreateUpdateEquipment,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(EquipmentModal);
